import { usePage } from "@inertiajs/react"
import { type ReactNode, useEffect, useRef } from "react"
import { toast } from "sonner"

import { Toaster } from "@/components/ui/sonner"
import type { SharedData } from "@/types"

interface PersistentLayoutProps {
  children: ReactNode
}

function FlashToasts() {
  const { flash } = usePage<SharedData>().props
  const prevFlashRef = useRef(flash)

  useEffect(() => {
    if (flash === prevFlashRef.current) return
    prevFlashRef.current = flash

    if (flash.notice) {
      toast.success(flash.notice)
    } else if (flash.alert) {
      toast.error(flash.alert)
    }
  }, [flash])

  return null
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      {children}
      <FlashToasts />
      <Toaster richColors />
    </div>
  )
}
